// extracted by mini-css-extract-plugin
module.exports = {"main-container":"SearchResults_main-container__80Hnd"};